import type { AxiosError } from 'axios';
import { t } from '@lingui/macro';

const errorHandle = (err: AxiosError) => {
    if (err.code === 'ERR_BAD_REQUEST' || err.code === 'ERR_BAD_RESPONSE') {
        let msg = '';

        switch (err.response?.status) {
            case 400:
                msg = t`Bad request.`;
                break;
            case 401:
                // if (!location.pathname.endsWith('login')) navigate.navigate('login');
                msg = t`Landing failure.`;

                // return Promise.resolve(`status to 401!`);
                break;
            case 403:
                msg = t`You are lack of permission.`;
                break;
            case 404:
                msg = t`API not found.`;
                break;
            case 500:
                msg = t`Server error.`;
                break;
            case 502:
                msg = t`Bad Gateway error.`;
                break;
            case 503:
                msg = t`Service Unavailable.`;
                break;
            default:
                msg = t`Unknown error`;
        }
    }

    return Promise.reject(err);
};

export default errorHandle;
